import { Navigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { isGlobalAdmin } from "../../utils/util";
import { ManageCompaniesActions } from "./ManageCompaniesActions";
import { ManageCompaniesList } from "./ManageCompaniesList";
import { useGetCompanies } from "../../hooks/companyHooks";
import { SoecoHeader } from "../../components/SoecoHeader";
import { useContext, useEffect, useState } from "react";
import { CompanyContext } from "../../context/CompanyContext";
import { EmployeeContext } from "../../context/EmployeeContext";
import { Company } from "../../types";

export const ManageCompanies = () => {
    const { company } = useContext(CompanyContext);
    const { data: companies } = useGetCompanies();
    const { companyId } = useParams();
    const { employee } = useContext(EmployeeContext);
    const [currentCompanies, setCurrentCompanies] = useState<Company[] | null>(null);
    // useEffect(() => {
    //     if (!currentCompanies) return;
    //     const sortedCompanies = currentCompanies.sort((a, b) => a.name.localeCompare(b.name));

    //     setCurrentCompanies(sortedCompanies);
    //     console.log("setting currentcompanies...");
    // }, [currentCompanies]);
    useEffect(() => {
        if (!companies || !employee) return;

        const isSoecoMain = companies.find(
            c => c.name === "Soeco Kontorsmöbler" && c.id === employee.companyId,
        );

        if (isSoecoMain) {
            setCurrentCompanies(companies);
            return;
        }

        const adminCompany = companies.find(c => c.id === companyId);
        if (!adminCompany) {
            setCurrentCompanies(null);
            return;
        }

        let visibleCompanies = companies.filter(
            c =>
                c.id === adminCompany.id ||
                c.superCompany === adminCompany.id ||
                c.createdBy === adminCompany.id,
        );

        if (employee.role === "superAdmin") {
            const firstLevelIds = visibleCompanies.map(c => c.id);
            const secondLevel = companies.filter(c => firstLevelIds.includes(c.superCompany ?? ""));
            visibleCompanies = [...visibleCompanies, ...secondLevel];
        }

        const uniqueCompanies = Array.from(new Map(visibleCompanies.map(c => [c.id, c])).values());

        setCurrentCompanies(uniqueCompanies);
    }, [companies, employee]);
    // TODO: It might be good to check if id is valid as well.
    if (!isGlobalAdmin) {
        return <Navigate to="/404" />;
    }

    return (
        <ManageCompaniesPageWrapper>
            <SoecoHeader>Manage Companies</SoecoHeader>
            <ManageCompaniesListWrapper>
                <ManageCompaniesList
                    company={company}
                    companies={currentCompanies?.sort((a, b) => a.name.localeCompare(b.name)) ?? []}
                    companyId={companyId || ""}
                />
            </ManageCompaniesListWrapper>
            <ManageCompaniesActions />
        </ManageCompaniesPageWrapper>
    );
};

const ManageCompaniesPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 80vh;
    align-items: center;
    gap: 2rem;
`;

const ManageCompaniesListWrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;
